import * as React from 'react'
import { LandingPagesLayout } from '../../shared/components/LandingPagesLayout'
import { createSignupLink } from '../../shared/utils/SignupForm';
import { Body } from './components/Body';

export const TermsAndConditions = () => {
  const {
    landingPageStrings,
    currentHost,
    topCities,
    privacyChoicesEnabled,
    currentCountry,
    locale,
    deviceCategory,
  } = window.gon

  return (
    <LandingPagesLayout
      signupLink={() => createSignupLink(currentHost)}
      footerContent={landingPageStrings.footer}
      currentHost={currentHost}
      currentCountry={currentCountry}
      locale={locale}
      topCities={topCities}
      privacyChoicesEnabled={privacyChoicesEnabled}
      className="px-7 xl:px-0"
    >
      <Body locale={locale} />
    </LandingPagesLayout>
  )
}
